/**
 * @Author: Zero
 * @Date: 2025-11-10 09:12:16
 * @Explain: 测试玩家管理模块
 */
export default {
  // 测试人列表
  'TESTER.MANAGE.LIST.CREATE': '构建测试用户池',
  'TESTER.MANAGE.LIST.CREATE.NEW.TESTER': '新建测试玩家列表',
  'TESTER.MANAGE.LIST.COPY.LINK': '注册&邀请链接',
  'TESTER.MANAGE.LIST.COPY.LINK.PLACEHOLDER': '注册链接待配置',
  'TESTER.MANAGE.LIST.COPY.REDIRECT.PLACEHOLDER': '点击在新页面打开链接',
  'TESTER.MANAGE.LIST.COPY.LINK.TIP': '复制注册&邀请链接',
  'TESTER.MANAGE.LIST.COPY.LINK.DISABLED.TIP': '配置未完成，无法复制链接',
  'TESTER.MANAGE.LIST.COPY.LINK.COPY.LINK.SUCCESS': '链接已复制',
  'TESTER.MANAGE.LIST.COPY.LINK.COPY.LINK.FAIL': '复制链接失败',
  'TESTER.MANAGE.LIST.COPY.LINK.DISABLED.TIP.HEADER.TITLE':
    '此链接可用作官网等渠道的<b>注册链接</b>，支持用户注册账号并报名参与测试。 若用于<b>邀请邮件</b>，已注册用户收到后可直接点击接受邀请。<br/><b>注意</b>： 测试链接的配置需联系 <a class="account" href="mailto:SmartLink_service@proximabeta.com">SmartLink_service@proximabeta.com</a> 完成。在此之前，您可以查阅 <a class="account" href="{ url }" target="_blank">用户手册</a> 了解相关详情。',
  'TESTER.MANAGE.LIST.COPY.LINK.DISABLED.TIP.HEADER.TEXT':
    '所有受邀的测试玩家点击邀请链接后，将进入以下网页流程以完成邀请流程。该流程及样式均可定制。',
  'TESTER.MANAGE.LIST.COPY.LINK.DISABLED.TIP.HEADER.CONTENT':
    '所有受邀的测试玩家点击邀请链接后，将进入以下网页流程以完成邀请流程。该流程及样式均可定制。',
  'TESTER.MANAGE.PLACEHOLDER.CREATE.ENTER.DESCRIPTION': '输入备注',
  'TESTER.MANAGE.PLACEHOLDER.CREATE.ENTER.NAME': '输入名称',
  'TESTER.MANAGE.CREATE.ENTER.NAME': '名称',
  'TESTER.MANAGE.CREATE.ENTER.DESCRIPTION': '备注',
  'TESTER.MANAGE.CREATE.VERIFY.NAME': '名字不能为空',
  'TESTER.MANAGE.CREATE.VERIFY.NAME.REPEAT': '当前输入的名字已存在',
  'TESTER.MANAGE.MODAL.TITLE': '新建测试玩家列表',
  'TESTER.MANAGE.EMPTY': '欢迎使用 Playtest Hub',
  'TESTER.MANAGE.EMPTY.EXAMPLE.TEST.MANAGE': '构建并管理测试用户池',
  'TESTER.MANAGE.EMPTY.EXAMPLE.TEST.INVITATION': '发送测试邀请与游戏兑换码',
  'TESTER.MANAGE.EMPTY.EXAMPLE.TEST.USER': '获取测试用户Discord、Steam 账号',
  'TESTER.MANAGE.EMPTY.EXAMPLE.CONFIDENTIALITY': '在线签署 NDA 保密协议',
  'TESTER.MANAGE.EMPTY.EXAMPLE.TEST.Discord': '将测试者自动加入 Discord社群',
  'TESTER.MANAGE.EMPTY.EXAMPLE.TEST.EASILY.COMPLETE':
    'SmartLink 让你轻松完成：',
  'TESTER.MANAGE.EMPTY.EXAMPLE.TEST.SUBTITLE':
    '集中管理你的测试玩家，打造高效、有序的游戏测试流程。',
  'TESTER.MANAGE.EMPTY.EXAMPLE.TEST.TIPS':
    '从招募到协作，一切尽在 SmartLink。让测试管理更高效，沟通更顺畅，体验更专业。',
  'TESTER.MANAGE.CONFIGURATION.INFORMATION': '配置信息',
  'TESTER.MANAGE.CONFIGURATION.INFORMATION.TAG':
    '{tagName}的联系人单向同步至列表,故标签移除不会影响此列表联系人数据',
  'TESTER.MANAGE.TESTER': '测试玩家',
  'TESTER.MANAGE.TESTER.NOT.CONFIG': '未配置',
  'TESTER.MANAGE.TESTER.INVITATION.JOURNEY': '邀请旅程',
  'TESTER.MANAGE.TESTER.SYNC': '测试玩家同步中，请稍后再试',
  'TESTER.MANAGE.TESTER.NOT.PLAYER.ADD': '当前无待邀请状态的测试玩家,请添加',
  'TESTER.MANAGE.TESTER.INVITATIONS.PROGRESS': '玩家邀请中....',
  'TESTER.MANAGE.TESTER.INVITATION.PLEASE.COMPLETE.THE': '请先激活',
  'TESTER.MANAGE.TESTER.LAST.INVITED.AT': '上次邀请是{CONTACT}在{DATE}',
  'TESTER.MANAGE.TESTER.LAST.SAVED.AT': '上次保存是{CONTACT}在{DATE}',
  'TESTER.MANAGE.TESTER.LAST.STATUS': '状态:',
  'TESTER.MANAGE.LIST.DISCORD.SENTIMENT': '情感分',
  'TESTER.MANAGE.LIST.DISCORD.SENTIMENT.TOOLTIPS':
    '基于多语种NLP情感分模型，给每1条发言或评论赋予情感分值，分为：负面(1分),中性(3分),正面(5分)。汇总情感分为各条发言或评论情感分加总求平均，分值范围为1-5。',
  'TESTER.MANAGE.LIST.CONTRIBUTION': '贡献度',
  'TESTER.MANAGE.TESTER.LAST.NOT.INVITED': '未邀请过',
  'TESTER.MANAGE.LIST.STATUS.WAITLIST': '待邀请',
  'TESTER.MANAGE.LIST.STATUS.INVITED': '已邀请',
  'TESTER.MANAGE.LIST.STATUS.ACCEPTED': '接受邀请',
  'TESTER.MANAGE.LIST.STATUS.ON.BOARDING': '接受邀请',
  'TESTER.MANAGE.LIST.STATUS.WAITING': '待邀请',
  'TESTER.MANAGE.LIST.STATUS.INVITE.LINK': '邀请链接',
  'TESTER.MANAGE.LIST.STATUS.INVITE.EMAIL': '邀请电子邮件',
  'TESTER.MANAGE.LIST.STATUS.ON.BOARDING.EMAIL': '资源码邮件',
  'TESTER.MANAGE.LIST.STATUS.WAITLIST.NOTES': '从标签新进入的联系人的初始状态',
  'TESTER.MANAGE.LIST.STATUS.INVITED.NOTES':
    '发起邀请后，联系人状态更新为已邀请。',
  'TESTER.MANAGE.LIST.STATUS.ACCEPTED.NOTES':
    '联系人完成了邀请链接中预设的流程（支持个性化设置）后，状态会更新为接受邀请。',
  'TESTER.MANAGE.LIST.STATUS.TITLE': '状态',
  // 测试人列表-按钮相关
  'TESTER.MANAGE.LIST.EDIT': '编辑',
  'TESTER.MANAGE.LIST.CONFIGURE': '配置',
  'TESTER.MANAGE.LIST.VIEW.DETAILS': '测试玩家列表',
  'TESTER.MANAGE.LIST.AI.ANALYTICS': 'AI分析',
  // 邀请旅程
  'TESTER.MANAGE.LIST.INVITATION JOURNEY': '邀请旅程',
  // 旅程状态文本
  'TESTER.MANAGE.LIST.STATUS.EDIT': '编辑',
  'TESTER.MANAGE.LIST.STATUS.SUSPEND': '暂停',
  'TESTER.MANAGE.LIST.STATUS.DETAILS': '详情',
  'TESTER.MANAGE.LIST.STATUS.REVIEWS.ERROR': '处理异常',

  // 测试管理列表
  'TESTER.MANAGE.TEST.LIST.FILTERS.MY.NO.REGION': '暂无区域',
  'TESTER.MANAGE.TEST.LIST.REGION': '区域',
  'TESTER.MANAGE.TEST.LIST.FILTERS.REGION.GROUP.TITLE': '区域',
  'TESTER.MANAGE.TEST.LIST.REGION.CUSTOM.AREA.GROUP.TITLE': '大区',
  'TESTER.MANAGE.TEST.LIST.FILTERS.REGION.GO.L':
    '可新建大区，移动Others内区域到新建大区中。<br/>快使用',
  'TESTER.MANAGE.TEST.LIST.FILTERS.REGION.GO.C': '区域管理',
  'TESTER.MANAGE.TEST.LIST.FILTERS.REGION.GO.R': '更新区域的大区划分吧',
  // 编辑标题-修改信息弹窗确认按钮
  'TESTER.MANAGE.TEST.LIST.HEADER.TITLE': '保存',
  // 修改测试人列表-标题
  'TESTER.MANAGE.TEST.LIST.EDIT.TESTER.TITLE': '编辑测试玩家列表',
  'TESTER.MANAGE.TEST.LIST.TITLE': '测试玩家列表',
  'TESTER.MANAGE.TEST.LIST.TITLE.NO.TESTERS.YET': '无测试玩家',
  'TESTER.MANAGE.TEST.LIST.SEARCH.NAME.PLACEHOLDER': '搜索玩家邮箱',
  'TESTER.MANAGE.TEST.LIST.SEARCH.STATUS': 'Status',
  // 邀请按钮
  'TESTER.MANAGE.TEST.LIST.INVITE.WAITING.TESTER': '邀请待邀请测试玩家',
  // 删除相关的按钮
  'TESTER.MANAGE.TEST.LIST.REMOVE.CONTACTS': '移除玩家',
  'TESTER.MANAGE.TEST.LIST.CONFIRM.REMOVE': '确认移除',
  // 展示对应的游戏的头像和名称
  'TESTER.MANAGE.TEST.LIST.PLATFORM.SOURCE': '连接来源：',
  'TESTER.MANAGE.TEST.LIST.PLATFORM.NOT.LINKED': '无',
  'TESTER.MANAGE.TEST.LIST.PLATFORM.NOT.LINKED.TIPS': '暂未关联{platform}游戏',
  'TESTER.MANAGE.TEST.LIST.PLATFORM.STEAM.LINKED':
    '通过 Steam API 追踪游戏时长和愿望单状态',
  'TESTER.MANAGE.TEST.LIST.PLATFORM.DISCORD.LINKED':
    '分析实时聊天记录中的情感倾向和贡献度',
  // 添加联系人
  'TESTER.MANAGE.TEST.LIST.AddCONTACT': '添加测试玩家',
  'TESTER.MANAGE.TEST.LIST.DIALOG.HEADER.ADD.TESTER': '添加测试玩家',
  'TESTER.MANAGE.TEST.LIST.DIALOG':
    '所选标签下的联系人会同步至测试玩家列表。新添加到该标签的联系人需重新添加标签。',
  'TESTER.MANAGE.TEST.LIST.DIALOG.SELECT.PLACEHOLDER': '选择标签',
  // 删除联系人 二次弹窗
  'TESTER.MANAGE.TEST.LIST.DIALOG.DELETE.TITLE': '确定批量移除测试玩家?',
  // 删除联系人 二次弹窗内容文本
  'TESTER.MANAGE.TEST.LIST.DIALOG.DELETE.CONTENT':
    '己选中{CONTENTCOUNT}个联系人。移除后，所有选中联系人不再会同步到列表中。',
  // 删除联系人 二次弹窗内容文本-确认文本
  'TESTER.MANAGE.TEST.LIST.DIALOG.DELETE.CONFIRM.BTN.TEXT': '确定',
  'TESTER.MANAGE.TEST.LIST.DIALOG.SELECTED.PLAYERS':
    '已选择: <b>{CONTACTS}个测试玩家<b>',
  'TESTER.MANAGE.TEST.LIST.DIALOG.EMAIL.SUBSCRIBERS': '已订阅邮箱数',
  'TESTER.MANAGE.TEST.LIST.DIALOG.EMAIL.CONTACTS': '邮箱总数',
  // 同步联系人 message
  'TESTER.MANAGE.TEST.LIST.SYNC.CONTACT': '已添加{CONTACT}个联系人',
  'TESTER.MANAGE.TEST.LIST.SYNC.ZERO.CONTACT': '该标签下暂无已订阅联系人可添加',
  // 同步联系人百分比
  'TESTER.MANAGE.TEST.LIST.SYNC.CONTACT.PROGRESS': '数据读取',
  // 添加 测试人员按钮 tooltip信息-别人在同步
  'TESTER.MANAGE.TEST.LIST.DISABLED.TOOLTIP.ADDING': '联系人添加中....',
  // 轮询 接口 数据被删除 返回列表页 文案
  'TESTER.MANAGE.TEST.LIST.SYNC.CONTACT.DATA.DELETE.TITLE': '测试被删除',
  'TESTER.MANAGE.TEST.LIST.SYNC.CONTACT.DATA.DELETE': '请返回列表页',
  // 确认邀请按钮文案
  'TESTER.MANAGE.TEST.LIST.CONFIRM.INVITATION': '确认邀请',
  'TESTER.MANAGE.TEST.LIST.SEND.AN.INVITATION': '邀请待邀请测试玩家',
  'TESTER.MANAGE.TEST.LIST.SEND.AN.INVITATION.SUBSCRIBERS.ON.THE.WAITLIST':
    '待邀请者',
  'TESTER.MANAGE.TEST.LIST.SEND.AN.INVITATION.SUBSCRIBERS': '待邀请订阅者',
  'TESTER.MANAGE.TEST.LIST.SEND.AN.INVITATION.TEXT':
    '确认后，本次邀请的已订阅测试玩家会进入到邀请旅程，请确认旅程配置;',
  // 旅程详情跳转
  'TESTER.MANAGE.TEST.LIST.SEND.AN.INVITATION.TEXT.JOURNEY.DETAILS': '旅程详情',
  // 表头相关
  'TESTER.MANAGE.TEST.LIST.TABLE.SUBSCRIPTION.STATUS': '订阅状态',
  'TESTER.MANAGE.TEST.LIST.TABLE.REGION': '地区',
  'TESTER.MANAGE.TEST.LIST.TABLE.LANGUAGE': '语言',
  'TESTER.MANAGE.TEST.LIST.TABLE.AUTHORIZATION.PLATFORM': '作者设备',
  'TESTER.MANAGE.TEST.LIST.TABLE.JOINED.LIST': '加入列表时间',
  'TESTER.MANAGE.TEST.LIST.TABLE.INVITED.TIME': '受邀时间',
  'TESTER.MANAGE.TEST.LIST.TABLE.START.TIME': '开始时间',
  'TESTER.MANAGE.TEST.LIST.TABLE.END.TIME': '结束时间',
  'TESTER.MANAGE.TEST.LIST.TABLE.STATUS': '状态',
  'TESTER.MANAGE.TEST.LIST.TABLE.EMAIL': '邮箱',
  'TESTER.MANAGE.TEST.LIST.TABLE.SUBSCRIBED': '已订阅',
  'TESTER.MANAGE.TEST.LIST.TABLE.PENDING': '待定',
  'TESTER.MANAGE.TEST.LIST.TABLE.UNSUBSCRIBED': '未订阅',
  'TESTER.MANAGE.TEST.LIST.TABLE.UNBOUND': '未绑定',
  'TESTER.MANAGE.TEST.LIST.TABLE.UNKNOWN': '未知',
  'TESTER.MANAGE.TEST.LIST.TABLE.DRAFT': '草稿',
  'TESTER.MANAGE.TEST.LIST.TABLE.ONGOING': '进行中',
  'TESTER.MANAGE.TEST.LIST.TABLE.ONGOING.JOURNEY.ERROR': '正在进行的行程错误',
  'TESTER.MANAGE.TEST.LIST.TABLE.SUSPENDED': '暂停',
  'TESTER.MANAGE.TEST.LIST.INVITATION.COMPLETE': '邀请已发送',
  'TESTER.MANAGE.TEST.LIST.INVITATION.FAILED': '邀请发送失败',
  'TESTER.MANAGE.TEST.LIST.DELETE': '已成功移除{deleteTesterNums}个测试玩家',
  'TESTER.MANAGE.TEST.LIST.EDIT.INFO': '编辑成功',
  'TESTER.MANAGE.TEST.LIST.IMPORT.CONTACT': '导入成功',
  'TESTER.MANAGE.TEST.LIST.CREATED.INFO': '创建成功',
  'TESTER.MANAGE.TEST.LIST.PLAYER ENTERED INVITATION JOURNEY':
    '玩家已进入邀请旅程',
  'TESTER.MANAGE.TEST.LIST.STEAM.KEY': 'Steam key',
  'TESTER.MANAGE.TEST.LIST.STEAM.KEY.NOT.SENT': '/',
  'TESTER.MANAGE.TEST.LIST.STEAM.KEY.FETCHING': '获取中',
  'TESTER.MANAGE.TEST.LIST.STEAM.KEY.NOT.EXCHANGED': '未兑换',
  'TESTER.MANAGE.TEST.LIST.STEAM.KEY.EXCHANGED': '已兑换',
  'TESTER.MANAGE.TEST.LIST.STEAM.KEY.LAST.UPDATED.AT': '上次更新 {updateTime}',
  // 引导内容
  'TESTER.MANAGE.TEST.LIST.PLAYER.GUID.TITLE': '测试列表使用指南',
  'TESTER.MANAGE.TEST.LIST.PLAYER.GUID.TIP1.TITLE': '玩家导入',
  'TESTER.MANAGE.TEST.LIST.PLAYER.GUID.TIP1':
    '点击"测试玩家列表"进入玩家列表页面，可通过选择标签批量导入玩家。<br/>新导入的玩家状态为"待邀请"，此状态下的玩家可被邀请进入测试旅程。',
  'TESTER.MANAGE.TEST.LIST.PLAYER.GUID.TIP2.TITLE': '邀请链接配置',
  'TESTER.MANAGE.TEST.LIST.PLAYER.GUID.TIP2':
    '每个测试的邀请链接都支持自定义配置，支持授予玩家不同的discord服务器角色和频道。<br/>请联系<a  href="mailto:SmartLink_service@proximabeta.com">SmartLink_service@proximabeta.com</a>完成邀请链接配置。<br/>如需获取受邀玩家在 Steam 和 Discord 平台的更多信息，您需要提供相应平台的授权信息，详情可参考<a href="https://docs.smartlink.intlgame.com/zh/function-guide/manage-playtesthub-configuration/" target="_blank">Playtest平台配置</a>。',
  'TESTER.MANAGE.TEST.LIST.PLAYER.GUID.TIP3.TITLE': '旅程配置',
  'TESTER.MANAGE.TEST.LIST.PLAYER.GUID.TIP3':
    '测试旅程定义了玩家被邀请后的自动化流程。<br/>您可以为每个测试项目配置专属的测试旅程。请提前在邮件模板中创建好邀请邮件和资源码邮件。',
  'TESTER.MANAGE.TEST.LIST.TOOLTIP.COLUMN': '列',
  'TESTER.MANAGE.TEST.LIST.TOOLTIP.COLUMN.SELECT': '选中要展示的列',
  'TESTER.MANAGE.TEST.LIST.TOOLTIP.APPLY': '应用',

  // 测试配置
  'TESTER.MANAGE.CONFIG.EDIT.NAME': 'Edit name & description',
  'TESTER.MANAGE.CONFIG.SELECT.CONTACTS.LABEL':
    '1、Includes contacts who match all selected tags.',
  'TESTER.MANAGE.CONFIG.SELECT.CONTACTS.PLACEHOLDER':
    '标签下的联系人会自动加入到测试列表',
  'TESTER.MANAGE.CONFIG.TEST': '2、Test configure',
  'TESTER.MANAGE.CONFIGURED': '已配置',
  'TESTER.MANAGE.NOT.CONFIGURED': '未配置',
  'TESTER.MANAGE.CONFIG.TEST.INVITED.TITLE': '受邀流程配置',
  'TESTER.MANAGE.CONFIG.TEST.INVITED.DESC':
    '此链接提供协议签署、绑定discord 或 steam的玩家受邀流程，请联系 XXXX@XXXX.com完成测试链接配置。',
  'TESTER.MANAGE.CONFIG.TEST.INVITED.LINK.COPY': '复制链接',
  'TESTER.MANAGE.CONFIG.TEST.INVITATION.TITLE': '邀请邮件配置',
  'TESTER.MANAGE.CONFIG.TEST.INVITATION.DESC':
    '请将第一步配置好的受邀流程链接粘贴到邮件模板中。<br/>联系人通过邀请邮件，接受测试邀请。',
  'TESTER.MANAGE.CONFIG.TEST.INVITATION.SENTING.TIPS':
    'The email is being sent; settings cannot be changed',
  'TESTER.MANAGE.CONFIG.TEST.RESOURCE.TITLE': '资源码邮件配置',
  'TESTER.MANAGE.CONFIG.TEST.RESOURCE.DESC':
    '联系人通过邀请邮件，接受测试邀请。<br/>联系人接受邀请，完成邀请流程后，系统会自动为联系人发送资源码邮件。',
  'TESTER.MANAGE.CONFIG.TEST.RESOURCE.NUM': '资源码数量：{num}',
  'TESTER.MANAGE.CONFIG.TEST.RESOURCE.UPLOAD': '上传',
  'TESTER.MANAGE.CONFIG.LEAVE.TITLE':
    'Do you want to save the changes you have made?',
  'TESTER.MANAGE.CONFIG.LEAVE.DESC':
    'Here is subtitle description description description description',
  'TESTER.MANAGE.CONFIG.SAVE.TITLE': 'Confirm to save the configuration?',
  'TESTER.MANAGE.CONFIG.SAVE.DESC':
    '<p>Confirm and save the configuration; contacts within the tags will be automatically synchronized to the configuration management page.</p><p style="margin-top: 16px;">You can enter the configuration management page to send invitations to contacts</p>',
  'TESTER.MANAGE.CONFIG.SAVE.GO.TESTER': 'Save and return test list',
  'TESTER.MANAGE.CONFIG.SAVE.GO.TEST': 'Save and enter test management',

  /** 删除弹窗 */
  'TESTER.MANAGE.DELETE.TITLE': '确认删除测试玩家列表？',
  'TESTER.MANAGE.DELETE.DESC': '删除{tester}后，测试玩家列表不可恢复。',

  'TEST.MANAGE.AI.ANALYTICS.DISABLED.TOOLTIP':
    '请联系 <a href="mailto:SmartLink_service@proximabeta.com">SmartLink_service@proximabeta.com</a> 完成Discord配置。',
  'TESTER.MANAGE.BIND': '已绑定',
  'TESTER.MANAGE.UNBIND': '未绑定',
};
